import ExpandableCard from '../../Components/ExpandableCard/ExpandableCard';

export const Interviews = ({
  interviews,
  preventEdit,
  handleSaveInterview,
  handleDelete,
}: {
  interviews: Interview[];
  preventEdit?: boolean;
  handleSaveInterview: (x: Interview) => void;
  handleDelete: (id?: string) => void;
}) => {
  return (
    <>
      {interviews.map((interview: Interview) => (
        <ExpandableCard
          key={interview.id}
          interview={interview}
          preventEdit={preventEdit}
          onSave={handleSaveInterview}
          handleDelete={handleDelete}
        />
      ))}
    </>
  );
};
